import { Button, type ButtonProps } from "@mui/material";
import { FixedFooter } from "web_myplann/Finances/Components/FixedFooter";
import {
	Resources,
	useResource,
} from "web_myplann/Infrastructure/Translations/Resources";

type Props = {
	onClick: () => void;
	title?: string;
} & ButtonProps;

export const FooterButton = ({ onClick, title, ...rest }: Props) => {
	const { t } = useResource();
	return (
		<FixedFooter bgcolor="background.default" zIndex={1000}>
			<Button
				variant="contained"
				color="primary"
				fullWidth
				onClick={onClick}
				{...rest}
			>
				{title ?? t(Resources.Common.continue)}
			</Button>
		</FixedFooter>
	);
};
